<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <section id="home-page">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">In Port List</h4>
                        </div>
                        <form class="add-new modal-content pt-0" [formGroup]="newFormFilter"
                            (ngSubmit)="onSubmitFilter()">
                            <div class="modal-body flex-grow-1">
                                <div class="row">
                                    <div class="col-lg-3">
                                        <div class="form-group">
                                            <label>Select Exporter<span class="text-danger">*</span></label>
                                            <ng-select formControlName="vendor_id" aria-describedby="register-vendor_id"
                                                [ngClass]="{ 'is-invalid': submitted && fr.vendor_id.errors }">
                                                <ng-option disabled selected value="0">Select Exporter</ng-option>
                                                <ng-option *ngFor="let expCat of vendorDropDown"
                                                    [value]="expCat.id">{{expCat.name}}</ng-option>
                                            </ng-select>
                                            <div *ngIf="submitted && fr.vendor_id.errors" class="invalid-feedback">
                                                <div *ngIf="fr.vendor_id.errors.required">Exporter is required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-3">
                                        <div class="form-group">
                                            <label>Select User<span class="text-danger">*</span></label>
                                            <ng-select formControlName="user_id" aria-describedby="register-user_id"
                                                [ngClass]="{ 'is-invalid': submitted && fr.user_id.errors }">
                                                <ng-option disabled selected value="0">Select User</ng-option>
                                                <ng-option *ngFor="let usr of userDropDown"
                                                    [value]="usr.id">{{usr.name}}</ng-option>
                                            </ng-select>
                                            <div *ngIf="submitted && fr.user_id.errors" class="invalid-feedback">
                                                <div *ngIf="fr.user_id.errors.required">User is required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-2">

                                        <div class="form-group">
                                            <label class="form-label">From Date</label>
                                            <input type="date" formControlName="start_date" id="start_date"
                                                placeholder="dd-mm-yyyy" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-lg-2">

                                        <div class="form-group">
                                            <label class="form-label">To Date</label>
                                            <input type="date" formControlName="end_date" id="end_date"
                                                placeholder="dd-mm-yyyy" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-lg-2">
                                        <div class="form-group">
                                            <label class="form-label">Container Details</label>
                                            <input type="text" formControlName="vehicle_details" id="vehicle_details"
                                                placeholder="Container Details" class="form-control">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-3">
                                        <div class="form-group">
                                            <button type="submit" class="btn btn-primary mr-1 " rippleEffect
                                                [disabled]="loading "> <span *ngIf="loading "
                                                    class="spinner-border spinner-border-sm mr-1 "></span>Go</button>
                                            <button type="reset" class="btn btn-primary mr-1 " (click)="resetReport()"
                                                rippleEffect [disabled]="loading ">
                                                <span *ngIf="loading "
                                                    class="spinner-border spinner-border-sm mr-1 "></span>
                                                <i data-feather="refresh-cw"
                                                    class="d-sm-none d-inline-block mr-0 mr-sm-1"></i>
                                                <span class="d-none d-sm-inline-block">Reset</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="card-body p-0 pb-1">
                            <div class="row m-0">
                                <div class="col-md-6 col-6">
                                    <div class="d-flex justify-content-between align-items-center ml-1">
                                        <label class="d-flex align-items-center">Show
                                            <select class="form-control mx-25" [(ngModel)]="lengths"
                                                (change)="loadPageLenghs($event)">
                                                <option value="15">15</option>
                                                <option value="30">30</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-6 col-6 d-flex justify-content-start justify-content-md-end">
                                    <div class="d-flex align-items-center justify-content-end pr-1 pb-1 pb-md-0 w-100">
                                        <!-- <button class="btn btn-primary ml-1" rippleEffect routerLink="/purchase/add"
                                            data-toggle="tooltip" data-popup="tooltip-custom" placement="top"
                                            container="body" ngbTooltip="Add New Purchase">
                                            <i data-feather="plus"
                                                class="d-sm-none d-inline-block mr-0 mr-sm-1"></i><span
                                                class="d-none d-sm-inline-block">Add New</span>
                                        </button> -->
                                        <!-- <button class="btn btn-warning ml-1" rippleEffect
                                            (click)="toggleSidebar('filter-sidebar')">
                                            <i data-feather="filter" class="d-sm-none d-inline-block mr-0 mr-sm-1"></i>
                                            <span class="d-none d-sm-inline-block">Filter</span>
                                        </button> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col p-0 table-responsive">
                                <div class="overlay" *ngIf="progressMainTable">
                                    <div class="spinner-grow" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                                <table class="table table-striped table-hover valign-middle text-dark">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Exporter</th>
                                            <th>User</th>
                                            <th>Date</th>
                                            <th>Container</th>
                                            <th>Consignee Name</th>
                                            <th>ETA</th>
                                            <th>Remark</th>
                                            <th>Status</th>
                                            <th>Port Date</th>
                                            <th>Port Days</th>
                                            <th>Bill Of Loading</th>
                                            <th>Telex Copy</th>
                                            <th>Other Document</th>
                                        </tr>
                                    </thead>
                                    <tbody *ngIf="inportList?.length != 0">
                                        <tr *ngFor="let ware of inportList; let ndx = index">
                                            <td>{{ndx+page+1}}</td>
                                            <td>{{ ware.vendor_name }}</td>
                                            <td>{{ ware.user_name }}</td>
                                            <td>{{ ware.date }}</td>
                                            <td>{{ ware.vehicle_details }}</td>
                                            <td>{{ ware.consignee_name }}</td>
                                            <td>{{ ware.eta }}</td>
                                            <td>{{ ware.remark }}</td>
                                            <td>
                                                <span class="badge badge-pill badge-light-warning mr-1"
                                                    *ngIf="ware.status == 1">In Transit</span>
                                                <span class="badge badge-pill badge-light-primary mr-1"
                                                    *ngIf="ware.status == 2">Received</span>
                                                <span class="badge badge-pill badge-light-primary mr-1"
                                                    *ngIf="ware.status == 3">In Port</span>
                                            </td>
                                            <td>{{ ware.port_date }}</td>
                                            <td>{{ ware.port_day }}</td>
                                            <td>
                                                <button class="btn btn-primary ml-1" rippleEffect
                                                    (click)="toggleSidebar('new-sidebar',ware.id,1)">
                                                    <i data-feather="plus"
                                                        class="d-sm-none d-inline-block mr-0 mr-sm-1"></i><span
                                                        class="d-none d-sm-inline-block">Add</span>
                                                </button>
                                                <a *ngIf="ware.bill_path != '' " [href]="ware.bill_path" target="_blank"
                                                    rel="noopener noreferrer"><button
                                                        class="btn btn-warning ml-1">view</button></a>
                                            </td>
                                            <td>
                                                <button class="btn btn-primary ml-1" rippleEffect
                                                    (click)="toggleSidebar('new-sidebar',ware.id,2)">
                                                    <i data-feather="plus"
                                                        class="d-sm-none d-inline-block mr-0 mr-sm-1"></i><span
                                                        class="d-none d-sm-inline-block">Add</span>
                                                </button>
                                                <a *ngIf="ware.telex_path != '' " [href]="ware.telex_path"
                                                    target="_blank" rel="noopener noreferrer"><button
                                                        class="btn btn-warning ml-1">view</button></a>
                                            </td>
                                            <td>
                                                <button class="btn btn-primary ml-1" rippleEffect
                                                    (click)="toggleSidebar('new-sidebar',ware.id,3)">
                                                    <i data-feather="plus"
                                                        class="d-sm-none d-inline-block mr-0 mr-sm-1"></i><span
                                                        class="d-none d-sm-inline-block">Add</span>
                                                </button>
                                                <a *ngIf="ware.other_path != '' " [href]="ware.other_path"
                                                    target="_blank" rel="noopener noreferrer"><button
                                                        class="btn btn-warning ml-1">view</button></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody *ngIf="inportList?.length == 0">
                                        <tr *ngIf="!loading">
                                            <td colspan="3" class="no-data-available">No Data!</td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="no-data-available">
                                                <div class="col" *ngIf="loading">
                                                    <div class="text-center">
                                                        <div class="spinner-border" role="status">
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                        <div>
                                                            Please Wait...
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <ngb-pagination class="d-flex justify-content-end mt-2 mr-2" *ngIf="collectionSize > 0"
                                    [collectionSize]="collectionSize" [pageSize]="lengths" [(page)]="pageBasicText"
                                    (pageChange)="loadPage($event)" aria-label="Custom pagination">
                                    <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'"
                                            [class]="'font-weight-bolder'"></span>Prev
                                    </ng-template>
                                    <ng-template ngbPaginationNext>Next<span [data-feather]="'chevron-right'"
                                            [class]="'font-weight-bolder'"></span>
                                    </ng-template>
                                </ngb-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
<!-- New User Sidebar -->
<core-sidebar class="modal modal-slide-in sidebar-todo-modal fade" name="new-sidebar" overlayClass="modal-backdrop">
    <div class="slideout-content">
        <!-- Modal to add new starts-->
        <div class="modalsd modal-slide-in sdfade new-modal" id="modals-slide-in">
            <div class="modal-dialog">
                <form class="add-new modal-content pt-0" [formGroup]="newFormAdd" (ngSubmit)="onSubmit()">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="toggleSidebar('new-sidebar')">
                        ×
                    </button>
                    <div class="modal-header mb-1">
                        <h5 class="modal-title" id="exampleModalLabel">Add File</h5>
                    </div>
                    <div class="modal-body flex-grow-1 ">
                        <div class="row m-0">
                            <div class="col">
                                <div class="form-group">
                                    <label for="register-file" class="form-label">File<span class="text-danger">*</span>
                                    </label>
                                    <input type="file" formControlName="file" class="form-control"
                                        placeholder="Select File" (change)="uploadFile($event,1)"
                                        aria-describedby="register-file"
                                        [ngClass]="{ 'is-invalid': submitted && f.file.errors }" />
                                    <div *ngIf="submitted && f.file.errors" class="invalid-feedback">
                                        <div *ngIf="f.file.errors.required">File is required</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-lg-12 p-0">
                                        <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
                                            <div class="alert-body">
                                                <p>{{ error }}</p>
                                            </div>
                                        </ngb-alert>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-lg-12 p-0">
                                        <button type="reset" class="btn btn-secondary"
                                            (click)="toggleSidebar('new-sidebar')" [disabled]="loadingFrm" rippleEffect>
                                            <span *ngIf="loadingFrm"
                                                class="spinner-border spinner-border-sm mr-1"></span>
                                            <i data-feather="x" class="d-sm-none d-inline-block mr-0 mr-sm-1"></i>
                                            <span class="d-none d-sm-inline-block">Cancel </span>
                                        </button>
                                        <button type="submit" class="btn btn-primary ml-1 " rippleEffect
                                            [disabled]="loadingFrm"> <span *ngIf="loadingFrm"
                                                class="spinner-border spinner-border-sm mr-1"></span>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- Modal to add new Ends-->
    </div>
</core-sidebar>
<!--/ New User Sidebar -->